// Account
export const me = () => 'users/me'

// fineTunedModels
export const appList = () => 'app'
export const appCreate = () => 'app'
export const appDestroy = appId => `app/${appId}`
export const torqData = () => 'app/torq_data'
export const torqFlow = () => 'app/torq_flow'
